import { render } from "./AdminRegisteredUsers.vue?vue&type=template&id=72ff2160&scoped=true"
import script from "./AdminRegisteredUsers.vue?vue&type=script&lang=js"
export * from "./AdminRegisteredUsers.vue?vue&type=script&lang=js"

import "./AdminRegisteredUsers.vue?vue&type=style&index=0&id=72ff2160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ff2160"]])

export default __exports__